import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IInvitation} from '@app/models/signup';
import {IIkCardSelectableIconItem} from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import {getClientSpaceOwnPaymentMethods} from '@app/invitation/invitation-b2b/shared/helpers/get-client-space-own-payment-methods';
import {getClientSpacePartnerPaymentMethods} from '@app/invitation/invitation-b2b/shared/helpers/get-client-space-partner-payment-methods';
import {TranslocoService} from '@ngneat/transloco';

@Component({
  selector: 'app-invitation-b2b-client-payment-list',
  templateUrl: './invitation-b2b-client-payment-list.component.html',
  styleUrls: ['./invitation-b2b-client-payment-list.component.scss']
})
export class InvitationB2bClientPaymentListComponent implements OnInit {
  @Input() invitation: IInvitation;
  @Input() selectedAccount: any;
  @Output() paymentSelected = new EventEmitter();

  customer: IIkCardSelectableIconItem[];
  partner: IIkCardSelectableIconItem[];

  selectedPayment: 'customer' | 'partner';

  constructor(private translocoService: TranslocoService) {
    this.customer = [];
    this.partner = [];
  }

  get wantCustomerPayment(): boolean {
    return this.invitation.extras.has_customer_payment_method;
  }

  ngOnInit(): void {
    this.selectedPayment = this.wantCustomerPayment
      ? 'customer'
      : 'partner';

    this.translocoService.langChanges$.subscribe(() => {
      this.customer = getClientSpaceOwnPaymentMethods();
      this.partner = getClientSpacePartnerPaymentMethods();
    });
  }

  switchPermission(permission: 'customer' | 'partner'): void {
    this.selectedPayment = permission;
    this.paymentSelected.emit(this.selectedPayment);
  }
}
